import { render, staticRenderFns } from "./cp_businessDxMenu.vue?vue&type=template&id=e13e2436&scoped=true"
import script from "./cp_businessDxMenu.vue?vue&type=script&lang=js"
export * from "./cp_businessDxMenu.vue?vue&type=script&lang=js"
import style0 from "./cp_businessDxMenu.vue?vue&type=style&index=0&id=e13e2436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13e2436",
  null
  
)

export default component.exports